var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('nav-bar'),_c('v-main',[_c('v-container',{staticClass:"pa-sm-6 pa-4 offsetApp"},[_c('router-view'),_c('side-drawer')],1)],1),_c('global-footer'),_c('report-popup'),_c('snack-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }